import Vue from "vue";
import VueRouter from "vue-router";
import Main from "./components/Main.vue";
import Login from "./components/Login.vue";
import {fetchAuthSession} from 'aws-amplify/auth';

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: Main,
        meta: {requiresAuth: true}, // Add meta field for route protection
    },
    {path: "/login", component: Login},

];

const router = new VueRouter({
    mode: "history", // Optional: Enables clean URLs
    routes,
});

router.beforeEach(async (to, from, next) => {
    try {
        // Attempt to fetch the current authenticated session
        const {tokens} = await fetchAuthSession({forceRefresh: true});
        console.log("tokens exists:", tokens);

        const isAuthenticated = !!tokens// Safely check if session exists
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (isAuthenticated) {
                console.log("Access granted.");
                next(); // Proceed to the protected route
            } else {
                console.log("Not authenticated. Redirecting to login...");
                next("/login"); // Redirect to login if not authenticated
            }
        } else {
            next(); // Allow navigation to non-protected routes
        }
    } catch (error) {
        console.log("No valid session:", error);
        //next("/login"); // Redirect to login if session is invalid
        //
        // if (to.matched.some(record => record.meta.requiresAuth)) {
        //     console.log("Redirecting to login...");
        //
        // } else {
        //     next("/print"); // Allow access to non-protected routes
        // }
    }
});
export default router;
